import { useState } from "react";
import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { SectionHeader } from "@/components/Bits";
import { BLOG_TOPICS, IMG } from "@/data/site";
import { ArrowUpRight } from "lucide-react";

const PER_PAGE = 30;

export default function Blog() {
  const [count, setCount] = useState(PER_PAGE);
  const shown = BLOG_TOPICS.slice(0, count);

  return (
    <>
      <Seo
        title="Ottawa, KS Travel Blog & Local Guide"
        description="The Super 8 Ottawa travel resource center — guides to things to do in Ottawa, Kansas, the Prairie Spirit Trail, local restaurants, fishing, road trips, business travel tips and more."
        path="/blog"
        image={IMG.downtown}
        breadcrumbs={[{ name: "Home", path: "/" }, { name: "Blog", path: "/blog" }]}
      />
      <PageHero
        kicker="Travel Resource Center"
        lines={["Stories", "from the", "prairie"]}
        sub="A growing library of local guides and travel tips to help you make the most of Ottawa, Kansas and the surrounding region."
        image={IMG.downtown}
        showCta={false}
      />

      <section className="mx-auto max-w-[1400px] px-5 py-24 md:px-10 md:py-32">
        <SectionHeader kicker="The Journal" title={`${BLOG_TOPICS.length}+ guides & ideas`} sub="Fresh articles are on the way. Here's what's coming to the Super 8 Ottawa travel blog." />
        <div className="mt-14 grid grid-cols-1 border-t border-charcoal/10 md:grid-cols-2">
          {shown.map((t, i) => (
            <Reveal
              key={i}
              i={i % 2}
              className="group flex items-center justify-between gap-4 border-b border-charcoal/10 py-6 md:odd:border-r md:odd:pr-8 md:even:pl-8"
            >
              <div className="flex items-baseline gap-4">
                <span className="font-body text-xs text-brand-red">{String(i + 1).padStart(3, "0")}</span>
                <h3 className="font-heading text-lg font-black leading-tight text-charcoal transition-colors duration-200 group-hover:text-brand-red">{t}</h3>
              </div>
              <ArrowUpRight className="h-4 w-4 shrink-0 text-fog transition-all duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-brand-red" />
            </Reveal>
          ))}
        </div>
        {count < BLOG_TOPICS.length && (
          <div className="mt-12 text-center">
            <button
              data-testid="load-more-blog"
              onClick={() => setCount((c) => c + PER_PAGE)}
              className="inline-flex items-center gap-2 border border-charcoal/25 px-8 py-4 font-heading font-black uppercase text-charcoal transition-colors duration-300 hover:border-brand-red hover:text-brand-red"
            >
              Load more topics
            </button>
          </div>
        )}
      </section>
    </>
  );
}
